var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
import { isCertificateSelected, sortCertificatesByAscExpiryDate } from '../helpers/certificatesUtils';
var useCertificateList = function (_a) {
    var activeCertificates = _a.activeCertificates;
    var _b = useState([]), selectedCertificates = _b[0], setSelectedCertificates = _b[1];
    var onChangeCertificates = function (certificate) {
        if (isCertificateSelected(certificate, selectedCertificates)) {
            setSelectedCertificates(function (prev) {
                return prev.filter(function (element) { return element.certificateNumber !== certificate.certificateNumber; });
            });
        }
        else {
            setSelectedCertificates(function (prev) { return __spreadArray(__spreadArray([], prev, true), [certificate], false); });
        }
    };
    var areAllSelected = function () {
        var _a;
        return (_a = activeCertificates === null || activeCertificates === void 0 ? void 0 : activeCertificates.certificateDetails) === null || _a === void 0 ? void 0 : _a.every(function (element) {
            return isCertificateSelected(element, selectedCertificates);
        });
    };
    var toggleAllItems = function () {
        if (areAllSelected()) {
            setSelectedCertificates([]);
        }
        else {
            setSelectedCertificates(sortCertificatesByAscExpiryDate(activeCertificates === null || activeCertificates === void 0 ? void 0 : activeCertificates.certificateDetails) || []);
        }
    };
    return {
        areAllSelected: areAllSelected,
        onChangeCertificates: onChangeCertificates,
        selectedCertificates: selectedCertificates,
        toggleAllItems: toggleAllItems
    };
};
export default useCertificateList;
